import React from "react";

const AntiRagging = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        src="/internalcomplaints.pdf"
        title="Internal Complaints Document"
        className="w-full h-full"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default AntiRagging;